import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 16px;
    align-items: flex-start;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 800px;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    border-radius: 12px;
    margin-top: 20px;
  }
`;

export const CardHeader = styled.div`
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: #ffffff;
  padding: 32px 24px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const DocumentTypeLabel = styled.div`
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

export const CardTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const CardSubtitle = styled.p`
  font-size: 16px;
  margin: 0;
  opacity: 0.95;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const TimerText = styled.div`
  margin-top: 12px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 16px;
  border-radius: 8px;
  display: inline-block;
`;

export const CardBody = styled.div`
  padding: 32px 24px;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #ecf0f1;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const InfoLabel = styled.span`
  font-size: 14px;
  color: #7f8c8d;
  font-weight: 600;
  flex-shrink: 0;
  width: 200px;

  @media (max-width: 768px) {
    width: auto;
    font-size: 13px;
  }
`;

export const InfoValue = styled.span`
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
  text-align: right;
  flex: 1;

  @media (max-width: 768px) {
    text-align: left;
    font-size: 15px;
  }
`;

export const BookingNumber = styled.strong`
  color: #3498db;
  font-size: 16px;
  letter-spacing: 0.5px;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 2px solid #ecf0f1;
  margin: 32px 0;
`;

export const SubmitButton = styled.button`
  padding: 16px 48px;
  background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(39, 174, 96, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: #bdc3c7;
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 18px 24px;
    font-size: 18px;
    min-height: 56px; /* Larger touch target */
  }
`;

export const SuccessMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #27ae60;

  h2 {
    font-size: 24px;
    margin: 0 0 12px 0;
    color: #27ae60;
  }

  p {
    font-size: 16px;
    color: #555;
    margin: 8px 0;
  }
`;

export const ErrorMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #e74c3c;

  h2 {
    font-size: 24px;
    margin: 0 0 12px 0;
    color: #e74c3c;
  }

  p {
    font-size: 16px;
    color: #555;
    margin: 8px 0;
  }
`;

export const ExpiredMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #f39c12;

  h2 {
    font-size: 24px;
    margin: 0 0 12px 0;
    color: #f39c12;
  }

  p {
    font-size: 16px;
    color: #555;
    margin: 8px 0;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #ffffff;

  p {
    margin-top: 20px;
    font-size: 16px;
  }
`;
